RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CompanyAddTileCollection = Marionette.CollectionView.extend({
        maxItems: 11,
        childView: views.CompanyAddTileItem,
        initialize: function () {
            const me = this;
            Marionette.CollectionView.prototype.initialize.apply(me, arguments);
            me.collection = new Backbone.Collection();

        },
        addTile: function (companyData) {
            // limit our collection size to 10. add then check since the same company added 2x won't grow collection
            this.collection.add(companyData);
            if (this.collection.length === this.maxItems) {
                this.collection.remove(this.collection.at(0));
            }

        },
        removeTile: function (companyData) {
            this.collection.remove(companyData);
        }
    });

});
